import styled from 'styled-components'
import { Swiper, SwiperSlide } from 'swiper/react'
import { BlogMediaFigure, BlogMediaWrapper } from '../../components/Blog/MediaElement'
import { baseTransition } from '../../lib/styles/Style'

export const StyledImageVideoFooter = styled.div<{ $show: boolean }>`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.2rem;
  padding-left: 0.5rem;
  opacity: ${({ $show }) => ($show ? 1 : 0)};
  ${baseTransition};
  transition-property: opacity;
`

export const ImageVideoSliderNavigation = styled.div`
  display: flex;
  gap: 1rem;
  flex: 0 1 auto;
  align-items: flex-start;
`
export const StyledImageVideoSwiper = styled(Swiper)`
  display: flex;
  width: 100%;
  height: 100%;
  gap: 0.5rem;
  border-radius: 4px;
`

export const StyledSwiperSlide = styled(SwiperSlide)`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 0.5rem;
`

export const ImageVideoWrapper = styled(BlogMediaWrapper)`
  height: auto;
  display: flex;
  flex-direction: column;
  margin-bottom: 3rem;
  gap: 0.5rem;
`
export const ImageVideoCaptionContainer = styled.div`
  overflow: hidden;
  flex: 1 0 auto;
  height: 3rem;
`

export const StyledImageVideoMediaFigure = styled(BlogMediaFigure)`
  img {
    aspect-ratio: 16/9;
    object-fit: cover;
  }
`
